import { GeneralModel } from "./general.model";

export class WeightGroup extends GeneralModel {
    isAuto: boolean;
}